<div class="flow-confirm-dialog">
  <div class="title-row">
    <h4 class="h4-medium">{{ data.title }}</h4>
    <flow-button type="tertiary" size="tiny" [icon]="iconService.Icon.cross" (click)="onCancel()"></flow-button>
  </div>

  <p *ngIf="data.description">{{ data.description }}</p>

  <div class="quantity-row" *ngIf="data.quantity">
    <ag-counter-field
      [label]="data.quantity.label"
      [value]="quantity()"
      [minimumNumber]="minimumQuantity"
      [maximumNumber]="data.quantity.max"
      [specificWidth]="152"
      (valueChanged)="onQuantityChanged($event)"></ag-counter-field>
  </div>

  <div class="alertbox" *ngIf="data.alertboxTitle">
    <div class="alert-title-row">
      <img [src]="iconService.Icon.i_letter_1" width="24" height="24" alt="" class="alert-icon" />
      <span class="p-medium alert-title">{{ data.alertboxTitle }}</span>
    </div>
    <p class="alert-description" *ngIf="data.alertboxDescription" [innerHTML]="data.alertboxDescription"></p>
  </div>

  <div class="button-row">
    <flow-button *ngIf="data.discardButtonText" type="tertiary" size="small" [label]="data.discardButtonText" (click)="onDiscard()"></flow-button>
    <flow-button type="secondary" size="small" [label]="cancelText" (click)="onCancel()"></flow-button>
    <flow-button [type]="confirmType" size="small" [label]="confirmText" (click)="onConfirm()"></flow-button>
  </div>
</div>
